import commonEnHK from './common_en-HK'

const supplierEnHK = {
  supplier: {
    ...commonEnHK,
  }
}

export default supplierEnHK